"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createProvider_1 = require("./createProvider");
exports.Autocomplete = createProvider_1.createProvider('Autocomplete');
exports.Search = createProvider_1.createProvider('Search', function (agent) { return agent.defaults({}); });
exports.SmartCollection = createProvider_1.createProvider('SmartCollection', function (agent) { return agent.defaults({}); });
exports.Recommendation = createProvider_1.createProvider('Recommendation');
exports.Content = createProvider_1.createProvider('Content');
//# sourceMappingURL=index.js.map